import { darken, lighten, styled } from "@mui/material/styles";

// Components
import { Menu, Typography } from "@mui/material";

// Theme
import theme from "../Theme";

const styledName = "Notification";

export const StyledWrapper = styled(Menu, { name: styledName })({
  "&": {
    ".MuiPaper-root": {
      borderRadius: "20px",
      minWidth: "420px",
      maxWidth: "500px",
    },

    ".MuiTabs-flexContainer": {
      height: "100%",
      borderBottom: `solid 2px ${theme.palette.background.default}`,
    },
    ".MuiTabs-root": {
      height: "40px",
      minHeight: 0,
    },
  },
});

export const StyledHeader = styled("div", { name: styledName })({
  "&": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0 20px 0 10px",
  },
});

export const StyledLabel = styled(Typography, { name: styledName })({
  "&": {
    textAlign: "start",
  },
});

export const StyledMarkAsRead = styled(Typography, { name: styledName })({
  "&": {
    fontSize: "1.4rem",
    cursor: "pointer",
    textWrap: "nowrap",
    flexGrow: 1,
    ":hover": {
      color: theme.palette.primary.main,
    },
  },
});

export const StyledNotifyList = styled("ul", { name: styledName })({
  "&": {
    width: "100%",
    overflowY: "scroll",
  },
});

export const StyledNotifyItem = styled(Typography, { name: styledName })({
  "&": {
    height: "60px",
    width: "100%",
    padding: "0 20px",
    borderBottom: `1px solid ${darken(theme.palette.background.default, 0.2)}`,
    backgroundColor: lighten(theme.palette.background.default, 0.5),
    cursor: "pointer",
    transition: "all 0.2s ease-in",
    "&.read": {
      backgroundColor: "white",
      color: theme.palette.grey[500],
    },
    ":hover": {
      backgroundColor: theme.palette.background.default,
    },
  },
});
